// Вкладки раздела «Креативы»: пул роликов, библиотека медиа, креативы сети, что работает (в меню — один пункт, DESIGN §4).
import { Link } from '@tanstack/react-router';

type Tab = '/creatives' | '/creatives/library' | '/creatives/network' | '/creatives/works';

export function CreativeTabs({ active }: { active: Tab }) {
  const cur = (t: Tab) => (active === t ? 'page' : undefined);
  return (
    <nav className="tabs" aria-label="Разделы креативов">
      {/* exact: иначе роутер считает «Пул» активным и на /creatives/library, /creatives/works */}
      <Link to="/creatives" activeOptions={{ exact: true }} aria-current={cur('/creatives')}>
        Пул роликов
      </Link>
      <Link to="/creatives/library" aria-current={cur('/creatives/library')}>
        Библиотека
      </Link>
      <Link to="/creatives/network" aria-current={cur('/creatives/network')}>
        Креативы сети
      </Link>
      <Link to="/creatives/works" aria-current={cur('/creatives/works')}>
        Что работает
      </Link>
    </nav>
  );
}
